import animator from 'canvas-animator'
import Xi from './Xi'
import XiPart from './XiPart'
import Title from './Title'
import TitleWord from './TitleWord'

export default class Animation extends animator.base.ShapeContainer {
  constructor (context = null, x = 0, y = 0, canvasWidth, canvasHeight) {
    super(context, x, y)
    this.xi = new Xi(context, 0, 0, canvasWidth, canvasHeight)
    this.title = new Title(context, 0, -TitleWord.height - Title.LINE_DELTA * 2)
    this.add(this.title)
    this.add(this.xi)
  }

  update (elapsed) {
    super.update(elapsed)

    if (this.total > XiPart.DELAY_TIME + XiPart.EXPLODE_TIME) {
      this.title.show()
    }
  }
}
